/**
 * @typedef {number} float
 */

export class PrepareAppRequest {
	/** @param {PrepareAppRequest} o */
	constructor(o) {
		/**@type {?string}*/this.token = o.token;
	}
}

export class PrepareAppResponse {
	/** @param {PrepareAppResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?PrepareAppData}*/this.data = o.data;
	}
}

export class PrepareAppData {
	/** @param {PrepareAppData} o */
	constructor(o) {
		/**@type {ConditionFilter[]} */this.conditionFilterOptions = o.conditionFilterOptions;
		/**@type {string} */this.conditionListVersionSfId = o.conditionListVersionSfId;
		/**@type {CoPay[]}*/this.coPayOptions = o.coPayOptions;
		/**@type {CostPer[]}*/this.costPerOptions = o.costPerOptions;
		/**@type {?Contract}*/this.contractInfo = o.contractInfo;
		/**@type {PicklistValue[]}*/this.declineReasons = o.declineReasons;
		/**@type {Contact[]}*/this.dependentList = o.dependentList;
		/**@type {?boolean}*/this.enrollmentDeclined = o.enrollmentDeclined;
		/**@type {Dependents[]}*/this.dependentsOptions = o.dependentsOptions;
		/**@type {Assumption[]}*/this.disclaimers = o.disclaimers;
		/**@type {DisposableIncome[]}*/this.disposableIncomeOptions = o.disposableIncomeOptions;
		/**@type {?string}*/this.email = o.email;
		/**@type {?Employer}*/this.employer = o.employer;
		/**@type {PicklistValue[]}*/this.familyTiers = o.familyTiers;
		/**@type {PicklistValue[]}*/this.genderOptions = o.genderOptions;
		/**@type {?boolean}*/this.hasAccount = o.hasAccount;
		/**@type {HighDeductible[]}*/this.highDeductibleOptions = o.highDeductibleOptions;
		/**@type {?string}*/this.hostname = o.hostname;
		/**@type {?Increments}*/this.increments = o.increments;
		/**@type {?boolean}*/this.isConcierge = o.isConcierge;
		/**@type {?boolean}*/this.isMember = o.isMember;
		/**@type {?boolean}*/this.isPaperEnrollment = o.isPaperEnrollment;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {MaritalStatus[]}*/this.maritalStatusOptions = o.maritalStatusOptions;
		/**@type {PicklistValue[]}*/this.nameSuffixOptions = o.nameSuffixOptions;
		/**@type {?boolean}*/this.notSaveUserProgress = o.notSaveUserProgress;
		/**@type {?EnrollmentPaymentDetails}*/this.paymentDetails = o.paymentDetails;
		/**@type {?boolean}*/this.isBillingEnabled = o.isBillingEnabled;
		/**@type {?string}*/this.payrollFrequencyMonthly = o.payrollFrequencyMonthly;
		/**@type {?string}*/this.payrollFrequencySelected = o.payrollFrequencySelected;
		/**@type {PicklistValue[]}*/this.phoneTypeOptions = o.phoneTypeOptions;
		/**@type {?Presets}*/this.presets = o.presets;
		/**@type {?QuoteInfo}*/this.quoteInfo = o.quoteInfo;
		/**@type {?RatedClass}*/this.ratedClass = o.ratedClass;
		/**@type {PicklistValue[]}*/this.relationshipOptions = o.relationshipOptions;
		/**@type {PicklistValue[]}*/this.stateOptions = o.stateOptions;
		/**@type {PicklistValue[]}*/this.states = o.states;
		/**@type {PicklistValue[]}*/this.studentStatusOptions = o.studentStatusOptions;
		/**@type {?string}*/this.uiFlow = o.uiFlow;
		/**@type {?string}*/this.distributionChannel = o.distributionChannel;
		/**@type {?string}*/this.enrollmentPlatformLink = o.enrollmentPlatformLink;
		/**@type {?string}*/this.userName = o.userName;
		/**@type {?Labels}*/this.riderLabels = o.riderLabels;
		/**@type {?ContractPolicy}*/this.policy = o.policy;
		/**@type {?Eligibility}*/this.eligibility = o.eligibility;
		/**@type {Assumption[]}*/this.limitations = o.limitations;
		/**@type {Assumption[]}*/this.frauds = o.frauds;
		/**@type {?boolean}*/this.stopScreenForUnderaged = o.stopScreenForUnderaged;
		/**@type {?string/undefined}*/this.token = o.token;
	}
}

export class ContractPolicy {
	/** @param {ContractPolicy} o */
	constructor(o) {
		/**@type {?boolean}*/this.subjectToERISA = o.subjectToERISA;
		/**@type {?number}*/this.severeSeparationPeriod = o.severeSeparationPeriod;
		/**@type {?number}*/this.rateGPeriod = o.rateGPeriod;
		/**@type {?string}*/this.policyAdmin = o.policyAdmin;
		/**@type {?Date}*/this.polEDate = o.polEDate;
		/**@type {?Date}*/this.polADate = o.polADate;
		/**@type {?string}*/this.parEmployer = o.parEmployer;
		/**@type {?number}*/this.numOfEmployees = o.numOfEmployees;
		/**@type {?number}*/this.moderateSeparationPeriod = o.moderateSeparationPeriod;
		/**@type {?number}*/this.minEligibilityAge = o.minEligibilityAge;
		/**@type {?number}*/this.maxEligibilityAge = o.maxEligibilityAge;
		/**@type {?string}*/this.hasPortability = o.hasPortability;
		/**@type {?string}*/this.erLegalEntityName = o.erLegalEntityName;
		/**@type {?string}*/this.deferredEffectiveDate = o.deferredEffectiveDate;
		/**@type {?string}*/this.contractNumber = o.contractNumber;
		/**@type {?string}*/this.classDescription = o.classDescription;
		/**@type {?number}*/this.childMaxEligibilityAge = o.childMaxEligibilityAge;
		/**@type {?number}*/this.catastrophicSeparationPeriod = o.catastrophicSeparationPeriod;
		/**@type {?number}*/this.catastrophicRecurrencyLimit = o.catastrophicRecurrencyLimit;
		/**@type {?number}*/this.benefitWaitingPeriod = o.benefitWaitingPeriod;
		/**@type {?float}*/this.ageReductionPercentage = o.ageReductionPercentage;
		/**@type {?number}*/this.ageReductionAge = o.ageReductionAge;
		/**@type {?boolean}*/this.ageReduction = o.ageReduction;
	}
}

export class Labels {
	/** @param {Labels} o */
	constructor(o) {
		/**@type {?string}*/this.chronic = o.chronic;
		/**@type {?string}*/this.mental = o.mental;
		/**@type {?string}*/this.maternity = o.maternity;
	}
}

export class QuoteInfo {
	/** @param {QuoteInfo} o */
	constructor(o) {
		/**@type {?BandRates}*/this.ratesPerAge = o.ratesPerAge;
		/**@type {?Tiers}*/this.tierFactors = o.tierFactors;
		/**@type {AgeBand[]}*/this.ageBands = o.ageBands;
		/**@type {?ContributionPerBandTier}*/this.employerContribution = o.employerContribution;
		/**@type {?number}*/this.chronicRider = o.chronicRider;
		/**@type {?number}*/this.mentalRider = o.mentalRider;
		/**@type {?number}*/this.maternityRider = o.maternityRider;
	}
}

export class ContributionPerBandTier {
	/** @param {ContributionPerBandTier} o */
	constructor(o) {
		/**@type {?ContributionPerTier}*/this.b1 = o.b1;
		/**@type {?ContributionPerTier}*/this.b2 = o.b2;
		/**@type {?ContributionPerTier}*/this.b3 = o.b3;
	}
}

export class ContributionPerTier {
	/** @param {ContributionPerTier} o */
	constructor(o) {
		/**@type {?Contribution}*/this.employeeOnly = o.employeeOnly;
		/**@type {?Contribution}*/this.employeeSpouse = o.employeeSpouse;
		/**@type {?Contribution}*/this.employeeChild = o.employeeChild;
		/**@type {?Contribution}*/this.family = o.family;
	}
}

export class Contribution {
	/** @param {Contribution} o */
	constructor(o) {
		/**@type {?float}*/this.amount = o.amount;
		/**@type {?float}*/this.percentage = o.percentage;
	}
}

export class BandRates {
	/** @param {BandRates} o */
	constructor(o) {
		/**@type {?Rates}*/this.b1 = o.b1;
		/**@type {?Rates}*/this.b2 = o.b2;
		/**@type {?Rates}*/this.b3 = o.b3;
	}
}

export class Rates {
	/** @param {Rates} o */
	constructor(o) {
		/**@type {?float}*/this.moderate = o.moderate;
		/**@type {?float}*/this.severe = o.severe;
		/**@type {?float}*/this.catastrophic = o.catastrophic;
		/**@type {?float}*/this.chronic = o.chronic;
		/**@type {?float}*/this.mental = o.mental;
		/**@type {?float}*/this.maternity = o.maternity;
	}
}

export class EnrollmentPaymentDetails {
	/** @param {EnrollmentPaymentDetails} o */
	constructor(o) {
		/**@type {?string}*/this.plaidEnvironment = o.plaidEnvironment;
		/**@type {?string}*/this.plaidLinkToken = o.plaidLinkToken;
		/**@type {?string}*/this.stripePublicKey = o.stripePublicKey;
		/**@type {PaymentMethodInfo[]}*/this.bankAccountsData = o.bankAccountsData;
		/**@type {?string}*/this.billingMethod = o.billingMethod;
		/**@type {?MicroDepositsBankAccount}*/this.microDepositsBankAccount = o.microDepositsBankAccount;
	}
}

export class MicroDepositsBankAccount {
	/** @param {MicroDepositsBankAccount} o */
	constructor(o) {
		/**@type {?string}*/this.plaidLinkToken = o.plaidLinkToken;
		/**@type {string}*/this.name = o.name;
		/**@type {string}*/this.officialName = o.officialName;
		/**@type {string}*/this.mask = o.mask;
		/**@type {string}*/this.accountId = o.accountId;
		/**@type {string}*/this.status = o.status;
	}
}

export class PaymentMethodInfo {
	/** @param {PaymentMethodInfo} o */
	constructor(o) {
		/**@type {?string}*/this.stripeId = o.stripeId;
		/**@type {?string}*/this.brand = o.brand;
		/**@type {?string}*/this.last4 = o.last4;
		/**@type {?Expiry}*/this.expiry = o.expiry;
		/**@type {?boolean}*/this.isDefault = o.isDefault;
		/**@type {?string}*/this.type = o.type;
		/**@type {?boolean}*/this.lastPaymentWithError = o.lastPaymentWithError;
		/**@type {?Map<string, string>}*/this.metadata = o.metadata;
	}
}

export class Expiry {
	/** @param {Expiry} o */
	constructor(o) {
		/**@type {?number}*/this.month = o.month;
		/**@type {?number}*/this.year = o.year;
	}
}

export class MaritalStatus {
	/** @param {MaritalStatus} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class Increments {
	/** @param {Increments} o */
	constructor(o) {
		/**@type {number[]}*/this.moderate = o.moderate;
		/**@type {number[]}*/this.severe = o.severe;
		/**@type {number[]}*/this.catastrophic = o.catastrophic;
		/**@type {number[]}*/this.chronic = o.chronic;
		/**@type {number[]}*/this.mental = o.mental;
		/**@type {number[]}*/this.maternity = o.maternity;
	}
}

export class HighDeductible {
	/** @param {HighDeductible} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class DisposableIncome {
	/** @param {DisposableIncome} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class Assumption {
	/** @param {Assumption} o */
	constructor(o) {
		/**@type {?string}*/this.bullet = o.bullet;
		/**@type {?string}*/this.title = o.title;
		/**@type {?string}*/this.language = o.language;
		/**@type {Assumption[]}*/this.items = o.items;
	}
}

export class Dependents {
	/** @param {Dependents} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class Contract {
	/** @param {Contract} o */
	constructor(o) {
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?string}*/this.contractType = o.contractType;
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.year1 = o.year1;
		/**@type {?string}*/this.year2 = o.year2;
		/**@type {?boolean}*/this.useBrellaEnrollment = o.useBrellaEnrollment;
		/**@type {RiderSelection[]}*/this.riderSelection = o.riderSelection;
		/**@type {?boolean}*/this.restrictFamilyMembers = o.restrictFamilyMembers;
		/**@type {?Date}*/this.policyEffectiveDate = o.policyEffectiveDate;
		/**@type {?Date}*/this.policyEndDate = o.policyEndDate;
		/**@type {?Date}*/this.policyAnniversaryDate = o.policyAnniversaryDate;
		/**@type {?string}*/this.employerName = o.employerName;
		/**@type {?string}*/this.contractNumber = o.contractNumber;
		/**@type {?string}*/this.contractGroupId = o.contractGroupId;
		/**@type {?string}*/this.groupType = o.groupType;
		/**@type {?string}*/this.policyNumber = o.policyNumber;
		/**@type {?string}*/this.accountId = o.accountId;
		/**@type {?string}*/this.planOffering = o.planOffering;
		/**@type {?string}*/this.newHireWaitingPeriod = o.newHireWaitingPeriod;
		/**@type {?number}*/this.newlyEligibleWindow = o.newlyEligibleWindow;
		/**@type {?number}*/this.minEligibilityAge = o.minEligibilityAge;
		/**@type {?number}*/this.maxEligibilityAge = o.maxEligibilityAge;
		/**@type {?string}*/this.policyAdmin = o.policyAdmin;
		/**@type {?string}*/this.issueState = o.issueState;
		/**@type {?number}*/this.eligibleLives = o.eligibleLives;
		/**@type {?string}*/this.enrollmentPeriodNewHires = o.enrollmentPeriodNewHires;
		/**@type {?Date}*/this.implementationTimestamp = o.implementationTimestamp;
		/**@type {?Date}*/this.enrollmentStartDate = o.enrollmentStartDate;
		/**@type {?Date}*/this.enrollmentEndDate = o.enrollmentEndDate;
		/**@type {?number}*/this.levelValue = o.levelValue;
		/**@type {?string}*/this.billingGroupField = o.billingGroupField;
		/**@type {?string}*/this.billingGroupCustomField = o.billingGroupCustomField;
		/**@type {Contact[]}*/this.teamMembers = o.teamMembers;
		/**@type {?string}*/this.enrollmentPlatform = o.enrollmentPlatform;
		/**@type {?string}*/this.enrollmentPlatformOther = o.enrollmentPlatformOther;
		/**@type {?string}*/this.commissionStructure = o.commissionStructure;
		/**@type {?Employer}*/this.agencyEmployerRelationship = o.agencyEmployerRelationship;
		/**@type {?string}*/this.childMaxEligibilityAge = o.childMaxEligibilityAge;
		/**@type {?boolean}*/this.showDocumentsOnPortals = o.showDocumentsOnPortals;
		/**@type {?Census}*/this.census = o.census;
		/**@type {?number}*/this.spouseMaxPortabilityAge = o.spouseMaxPortabilityAge;
		/**@type {?number}*/this.newlyEligibleChildrenAutoCovered = o.newlyEligibleChildrenAutoCovered;
		/**@type {?number|undefined}*/this.newlyEligibleAdoptedAutoCovered = o.newlyEligibleAdoptedAutoCovered;
		/**@type {?number|undefined}*/this.newlyEligibleNewbornAutoCovered = o.newlyEligibleNewbornAutoCovered;
		/**@type {?string}*/this.carrier = o.carrier;
		/**@type {EnrollmentEvent[]}*/this.enrollmentEvents = o.enrollmentEvents;
		/**@type {?string}*/this.renewedToContractId = o.renewedToContractId;
		/**@type {?string}*/this.renewedFromContractId = o.renewedFromContractId;
		/**@type {?string}*/this.amendedFromContractId = o.amendedFromContractId;
		/**@type {?string}*/this.amendedToContractId = o.amendedToContractId;
		/**@type {AdjustmentLogs[]}*/this.adjustmentLogs = o.adjustmentLogs;
		/**@type {?string}*/this.groupSizeSegment = o.groupSizeSegment;
		/**@type {?Date}*/this.gracePeriodEndDate = o.gracePeriodEndDate;
		/**@type {?string}*/this.status = o.status;
		/**@type {ConditionListVersionContract[]}*/this.conditionListVersion = o.conditionListVersion;
		/**@type {?string}*/this.carrierSpecificPolicyId = o.carrierSpecificPolicyId
		/**@type {?boolean}*/this.requiresCarrierSpecificPolicyId = o.requiresCarrierSpecificPolicyId;
		/**@type {ContractChanges[]}*/this.contractTerms = o.contractTerms;
		/**@type {?Date}*/this.contractVersionStartDate = o.contractVersionStartDate;
		/**@type {?string}*/this.endorsementNumber = o.endorsementNumber;
		/**@type {?boolean}*/this.civilUnionDefaultValue = o.civilUnionDefaultValue;
		/**@type {?boolean}*/this.domesticPartnerDefaultValue = o.domesticPartnerDefaultValue;
		/**@type {Question[]}*/this.questions = o.questions;
	}
}

export class Question {
	/** @param {Question} o */
	constructor(o) {
		/**@type {?string}*/this.developerName = o.developerName;
		/**@type {?string}*/this.defaultValue = o.defaultValue;
		/**@type {?string}*/this.label = o.label;
		/**@type {?boolean}*/this.show = o.show;
	}
}

export class ContractChanges {
	/** @param {ContractChanges} o */
	constructor(o) {
		/**@type {?string}*/this.withinRG = o.withinRG;
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?string}*/this.recordType = o.recordType;
		/**@type {?string}*/this.planOrContractChange = o.planOrContractChange;
		/**@type {?string}*/this.offeringChange = o.offeringChange;
		/**@type {?string}*/this.name = o.name;
		/**@type {?string}*/this.initiatedUserId = o.initiatedUserId;
		/**@type {?Date}*/this.initiatedDate = o.initiatedDate;
		/**@type {?string}*/this.contractId = o.contractId;
	}
}

export class ConditionListVersionContract {
	/** @param {ConditionListVersionContract} o */
	constructor(o) {
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.url = o.url;
		/**@type {?Date}*/this.effectiveDate = o.effectiveDate;
		/**@type {?Date}*/this.endDate = o.endDate;
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
	}
}

export class AdjustmentLogs {
	/** @param {AdjustmentLogs} o */
	constructor(o) {
		/**@type {?string}*/this.addressChangeInformation = o.addressChangeInformation;
		/**@type {?string}*/this.adjustmentLogId = o.adjustmentLogId;
		/**@type {?string}*/this.adjustmentLogName = o.adjustmentLogName;
		/**@type {?string}*/this.assetGroupId = o.assetGroupId;
		/**@type {?string}*/this.assetId = o.assetId;
		/**@type {?string}*/this.contactId = o.contactId;
		/**@type {?string}*/this.contractId = o.contractId;
		/**@type {?Date}*/this.coverageEffectiveDate = o.coverageEffectiveDate;
		/**@type {?Date}*/this.coverageEndDate = o.coverageEndDate;
		/**@type {?string}*/this.createdByUserId = o.createdByUserId;
		/**@type {?Date}*/this.createdDate = o.createdDate;
		/**@type {?string}*/this.employerId = o.employerId;
		/**@type {?Date}*/this.enrollmentReceivedDate = o.enrollmentReceivedDate;
		/**@type {?string}*/this.offeringChange = o.offeringChange;
		/**@type {?Date}*/this.qualifyingLifeEventDate = o.qualifyingLifeEventDate;
		/**@type {?string}*/this.reason = o.reason;
		/**@type {?string}*/this.recordTypeName = o.recordTypeName;
		/**@type {?string}*/this.status = o.status;
		/**@type {?string}*/this.terminationReason = o.terminationReason;
		/**@type {?string}*/this.virtualCertificateId = o.virtualCertificateId;
		/**@type {?boolean}*/this.withinRateGuarantee = o.withinRateGuarantee;
	}
}

export class EnrollmentEvent {
	/**@param {EnrollmentEvent} o */
	constructor(o){
		/**@type {?boolean}*/this.reEnrollRequired = o.reEnrollRequired;
		/**@type {?string}*/this.preEnrollmentEducationLaunchDate = o.preEnrollmentEducationLaunchDate;
		/**@type {?string}*/this.openEnrollmentId = o.openEnrollmentId;
		/**@type {?Date}*/this.enrollmentStartDate = o.enrollmentStartDate;
		/**@type {?boolean}*/this.enrollmentSetUp = o.enrollmentSetUp;
		/**@type {?string}*/this.enrollmentEventType = o.enrollmentEventType;
		/**@type {?Date}*/this.enrollmentEndDate = o.enrollmentEndDate;
		/**@type {?boolean}*/this.enableOEEventOnERPortal = o.enableOEEventOnERPortal;
		/**@type {?string}*/this.contractId = o.contractId;
		/**@type {?boolean}*/this.confirmedEligibleEmployees = o.confirmedEligibleEmployees;
		/**@type {?string}*/this.status = o.status;
		/**@type {?boolean}*/this.useBrellaEnrollment = o.useBrellaEnrollment;
		/**@type {?EnrollmentEventRenewedContract}*/this.renewedContract = o.renewedContract;
	}
}

export class EnrollmentEventRenewedContract {
	/** @param {EnrollmentEventRenewedContract} o */
	constructor(o) {
		/**@type {?string}*/this.contractId = o.contractId;
		/**@type {?Date}*/this.policyEffectiveDate = o.policyEffectiveDate;
		/**@type {RatedClass[]}*/this.ratedClasses = o.ratedClasses;
	}
}

export class RatedClass {
	/** @param {RatedClass} o */
	constructor(o) {
		/**@type {RatedClassEmployerContribution[]}*/this.employerContributions = o.employerContributions;
		/**@type {?string}*/this.contributionType = o.contributionType;
		/**@type {?GroupClass}*/this.groupClass = o.groupClass;
		/**@type {?ContractTerms}*/this.contractTerms = o.contractTerms;
		/**@type {RatedClassRates[]}*/this.ratedClassRates = o.ratedClassRates;
		/**@type {?string}*/this.quoteId = o.quoteId;
	}
}

export class RatedClassRates {
	/** @param {RatedClassRates} o */
	constructor(o) {
		/**@type {?float}*/this.ageBandRate = o.ageBandRate;
		/**@type {?float}*/this.employerRateFactor = o.employerRateFactor;
		/**@type {?string}*/this.category = o.category;
		/**@type {?string}*/this.ageBand = o.ageBand;
		/**@type {Rate[]}*/this.rates = o.rates;
	}
}

export class Rate {
	/** @param {Rate} o */
	constructor(o) {
		/**@type {?string}*/this.familyTier = o.familyTier;
		/**@type {?float}*/this.rate = o.rate;
	}
}

export class ContractTerms {
	/** @param {ContractTerms} o */
	constructor(o) {
		/**@type {?number}*/this.ageReductionAge = o.ageReductionAge;
		/**@type {?float}*/this.ageReductionPercentage = o.ageReductionPercentage;
		/**@type {?boolean}*/this.ageReduction = o.ageReduction;
		/**@type {?number}*/this.bandingType = o.bandingType;
		/**@type {?Ages}*/this.ages = o.ages;
		/**@type {AgeBand[]}*/this.ageBands = o.ageBands;
		/**@type {?number}*/this.benefitWaitingPeriod = o.benefitWaitingPeriod;
		/**@type {?number}*/this.catastrophicCoverageLimit = o.catastrophicCoverageLimit;
		/**@type {?number}*/this.catastrophicMaximumOccurrences = o.catastrophicMaximumOccurrences;
		/**@type {?number}*/this.catastrophicSeparationPeriod = o.catastrophicSeparationPeriod;
		/**@type {?number}*/this.maternitySeparationPeriod = o.maternitySeparationPeriod;
		/**@type {?boolean}*/this.chronicBrokerRequested = o.chronicBrokerRequested;
		/**@type {?number}*/this.chronicCoverageLimit = o.chronicCoverageLimit;
		/**@type {?number}*/this.chronicMaximumOccurrences = o.chronicMaximumOccurrences;
		/**@type {?string}*/this.deferredEffectiveDate = o.deferredEffectiveDate;
		/**@type {?string}*/this.familyTier = o.familyTier;
		/**@type {?string}*/this.id = o.id;
		/**@type {?boolean}*/this.mentalBrokerRequested = o.mentalBrokerRequested;
		/**@type {?number}*/this.mentalCoverageLimit = o.mentalCoverageLimit;
		/**@type {?number}*/this.mentalMaximumOccurrences = o.mentalMaximumOccurrences;
		/**@type {?boolean}*/this.maternityBrokerRequested = o.maternityBrokerRequested;
		/**@type {?number}*/this.maternityCoverageLimit = o.maternityCoverageLimit;
		/**@type {?number}*/this.maternityMaximumOccurrences = o.maternityMaximumOccurrences;
		/**@type {?number}*/this.moderateCoverageLimit = o.moderateCoverageLimit;
		/**@type {?number}*/this.moderateSeparationPeriod = o.moderateSeparationPeriod;
		/**@type {?string}*/this.newHireEnrollmentPeriod = o.newHireEnrollmentPeriod;
		/**@type {?string}*/this.newHireWaitingPeriod = o.newHireWaitingPeriod;
		/**@type {?string}*/this.planOffering = o.planOffering;
		/**@type {?string}*/this.portability = o.portability;
		/**@type {?number}*/this.rateGuaranteePeriod = o.rateGuaranteePeriod;
		/**@type {?boolean}*/this.restrictFamilyMembers = o.restrictFamilyMembers;
		/**@type {?number}*/this.severeCoverageLimit = o.severeCoverageLimit;
		/**@type {?number}*/this.severeSeparationPeriod = o.severeSeparationPeriod;
		/**@type {?Eligibility}*/this.eligibility = o.eligibility;
		/**@type {?string}*/this.percentagePayableDuringBenefitWaitingPeriod = o.percentagePayableDuringBenefitWaitingPeriod;
		/**@type {?Presets}*/this.presets = o.presets;
		/**@type {?string}*/this.employeeShoppingLink = o.employeeShoppingLink;
		/**@type {?string}*/this.employeeShoppingCode = o.employeeShoppingCode;
		/**@type {?number}*/this.participationMinimum = o.participationMinimum;
		/**@type {?Tiers}*/this.tiers = o.tiers;
		/**@type {?string}*/this.separationPeriodAdmLogic = o.separationPeriodAdmLogic;
		/**@type {?string}*/this.catLifetimeOccurrenceLimitAdmLogic = o.catLifetimeOccurrenceLimitAdmLogic;
		/**@type {?string}*/this.moderateCalendarOccurrenceLimit = o.moderateCalendarOccurrenceLimit;
		/**@type {?string}*/this.severeCalendarOccurrenceLimit = o.severeCalendarOccurrenceLimit;
		/**@type {?string}*/this.catastrophicCalendarOccurrenceLimit = o.catastrophicCalendarOccurrenceLimit;
	}
}

export class Tiers {
	/** @param {Tiers} o */
	constructor(o) {
		/**@type {?float}*/this.employeeOnly = o.employeeOnly;
		/**@type {?float}*/this.employeeSpouse = o.employeeSpouse;
		/**@type {?float}*/this.employeeChild = o.employeeChild;
		/**@type {?float}*/this.family = o.family;
		/**@type {?boolean}*/this.childEligibility = o.childEligibility;
		/**@type {?boolean}*/this.spouseEligibilityRules = o.spouseEligibilityRules;
	}
}

export class Presets {
	/** @param {Presets} o */
	constructor(o) {
		/**@type {?Preset}*/this.value = o.value;
		/**@type {?Preset}*/this.premier = o.premier;
		/**@type {?Preset}*/this.enhanced = o.enhanced;
		/**@type {?Preset}*/this.custom = o.custom;
	}
}

export class Preset {
	/** @param {Preset} o */
	constructor(o) {
		/**@type {?float}*/this.severe = o.severe;
		/**@type {?float}*/this.moderate = o.moderate;
		/**@type {?float}*/this.catastrophic = o.catastrophic;
		/**@type {?boolean}*/this.show = o.show;
	}
}

export class Eligibility {
	/** @param {Eligibility} o */
	constructor(o) {
		/**@type {?string}*/this.benefitTerminationRules = o.benefitTerminationRules;
		/**@type {?float}*/this.activelyAtWorkHours = o.activelyAtWorkHours;
		/**@type {?boolean}*/this.onlyUnmarried = o.onlyUnmarried;
		/**@type {?boolean}*/this.civilUnionEligible = o.civilUnionEligible;
		/**@type {?boolean}*/this.domesticPartnerEligible = o.domesticPartnerEligible;
		/**@type {?boolean}*/this.subjectToERISA = o.subjectToERISA;
		/**@type {?string}*/this.groupClassId = o.groupClassId;
		/**@type {?boolean}*/this.cobra = o.cobra;
		/**@type {?boolean}*/this.leaveAbsenceMedicalLeaveFMLA = o.leaveAbsenceMedicalLeaveFMLA;
		/**@type {?boolean}*/this.leaveAbsenceMilitaryLeave = o.leaveAbsenceMilitaryLeave;
		/**@type {?boolean}*/this.leaveAbsenceOther = o.leaveAbsenceOther;
		/**@type {?boolean}*/this.leaveAbsenceQuarantine = o.leaveAbsenceQuarantine;
		/**@type {?boolean}*/this.leaveAbsenceSabbatical = o.leaveAbsenceSabbatical;
		/**@type {?boolean}*/this.leaveAbsenceSicknessAndInjury = o.leaveAbsenceSicknessAndInjury;
		/**@type {?boolean}*/this.laborStrike = o.laborStrike;
		/**@type {?boolean}*/this.furlough = o.furlough;
		/**@type {?boolean}*/this.coverageContinued = o.coverageContinued;
		/**@type {?boolean}*/this.coverageNotContinued = o.coverageNotContinued;
	}
}

export class AgeBand {
	/** @param {AgeBand} o */
	constructor(o) {
		/**@type {?number}*/this.ageTo = o.ageTo;
		/**@type {?number}*/this.ageFrom = o.ageFrom;
		/**@type {?string}*/this.ageBand = o.ageBand;
	}
}

export class Ages {
	/** @param {Ages} o */
	constructor(o) {
		/**@type {?number}*/this.rateB3AgeTo = o.rateB3AgeTo;
		/**@type {?number}*/this.rateB3AgeFrom = o.rateB3AgeFrom;
		/**@type {?number}*/this.rateB2AgeTo = o.rateB2AgeTo;
		/**@type {?number}*/this.rateB2AgeFrom = o.rateB2AgeFrom;
		/**@type {?number}*/this.rateB1AgeTo = o.rateB1AgeTo;
		/**@type {?number}*/this.rateB1AgeFrom = o.rateB1AgeFrom;
	}
}

export class RatedClassEmployerContribution {
	/** @param {RatedClassEmployerContribution} o */
	constructor(o) {
		/**@type {?float}*/this.amount = o.amount;
		/**@type {?float}*/this.percentage = o.percentage;
		/**@type {?string}*/this.familyTier = o.familyTier;
		/**@type {?string}*/this.ageBand = o.ageBand;
	}
}

export class GroupClass {
	/** @param {GroupClass} o */
	constructor(o) {
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.description = o.description;
		/**@type {?string}*/this.documentDescription = o.documentDescription;
		/**@type {?string}*/this.name = o.name;
	}
}

export class Census {
	/** @param {Census} o */
	constructor(o) {
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?string}*/this.id = o.id;
		/**@type {?boolean}*/this.isActive = o.isActive;
		/**@type {?number}*/this.eligibleEmployees = o.eligibleEmployees;
		/**@type {?string}*/this.censusNumber = o.censusNumber;
		/**@type {?string}*/this.censusName = o.censusName;
		/**@type {?Employer}*/this.agencyEmployerRelationship = o.agencyEmployerRelationship;
	}
}

export class Employer {
	/** @param {Employer} o */
	constructor(o) {
		/**@type {?string}*/this.agencyBrokerageId = o.agencyBrokerageId;
		/**@type {?string}*/this.taxId = o.taxId;
		/**@type {?string}*/this.sic = o.sic;
		/**@type {?string}*/this.proposalAffiliatesSubsidiaries = o.proposalAffiliatesSubsidiaries;
		/**@type {PayrollFrequencies[]}*/this.payrollFrequencies = o.payrollFrequencies;
		/**@type {?string}*/this.name = o.name;
		/**@type {?string}*/this.legalEntityName = o.legalEntityName;
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.affiliatesSubsidiaries = o.affiliatesSubsidiaries;
		/**@type {?Address}*/this.address = o.address;
		/**@type {?float}*/this.accountBalance = o.accountBalance;
		/**@type {?string}*/this.accountBalanceString = o.accountBalanceString;
		/**@type {?string}*/this.paymentsUnappliedAmountString = o.paymentsUnappliedAmountString;
		/**@type {?string}*/this.accountStatus = o.accountStatus;
		/**@type {?string}*/this.billingFrequency = o.billingFrequency;
		/**@type {?string}*/this.billingMethod = o.billingMethod;
		/**@type {?number}*/this.numberOfEligibleEmployees = o.numberOfEligibleEmployees;
		/**@type {?boolean}*/this.healthInsuranceSponsor = o.healthInsuranceSponsor;
		/**@type {string[]}*/this.supplementalPlans = o.supplementalPlans;
		/**@type {?string}*/this.prorationMethod = o.prorationMethod;
		/**@type {?float}*/this.washThreshold = o.washThreshold;
		/**@type {?Contract}*/this.contract = o.contract;
		/**@type {?string}*/this.selfBillThreshold = o.selfBillThreshold;
		/**@type {?string|undefined}*/this.dbaName = o.dbaName;
		/**@type {?string|undefined}*/this.timezone = o.timezone;
		/**@type {?string|undefined}*/this.businessPhone = o.businessPhone;
	}
}

export class PayrollFrequencies {
	/** @param {PayrollFrequencies} o */
	constructor(o) {
		/**@type {?string}*/this.payrollFrequency = o.payrollFrequency;
		/**@type {?Date}*/this.lastModifiedDate = o.lastModifiedDate;
		/**@type {?Date}*/this.createdDate = o.createdDate;
	}
}

export class Contact {
	/**@param {Contact} o */
	constructor(o) {
		/**@type {?string}*/this.accountId = o.accountId;
		/**@type {?Address}*/this.address = o.address;
		/**@type {?string}*/this.billingGroup = o.billingGroup;
		/**@type {?Date}*/this.birthDate = o.birthDate;
		/**@type {?string}*/this.contactPreference = o.contactPreference;
		/**@type {?Date}*/this.dateOfHire = o.dateOfHire;
		/**@type {?Date}*/this.effectiveDate = o.effectiveDate;
		/**@type {?Date}*/this.originalEffectiveDate = o.originalEffectiveDate;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.employmentStatus = o.employmentStatus;
		/**@type {?Date}*/this.enrollmentReceivedDate = o.enrollmentReceivedDate;
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.gender = o.gender;
		/**@type {?string}*/this.homePhone = o.homePhone;
		/**@type {?boolean}*/this.isQualifiedForCoverage = o.isQualifiedForCoverage;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {?string}*/this.middleName = o.middleName;
		/**@type {?string}*/this.mobilePhone = o.mobilePhone;
		/**@type {?string}*/this.nationalProducerNumber = o.nationalProducerNumber;
		/**@type {?Date}*/this.newNewHireOpenEnrollmentStartDate = o.newNewHireOpenEnrollmentStartDate;
		/**@type {?Date}*/this.newNewHireOpenEnrollmentEndDate = o.newNewHireOpenEnrollmentEndDate;
		/**@type {?string}*/this.payrollFrequency = o.payrollFrequency;
		/**@type {?string}*/this.billingFrequency = o.billingFrequency;
		/**@type {?string}*/this.phone = o.phone;
		/**@type {?string}*/this.relToEmployee = o.relToEmployee;
		/**@type {?string}*/this.socialSecurityNumber = o.socialSecurityNumber;
		/**@type {?string}*/this.suffix = o.suffix;
		/**@type {?Date}*/this.terminationDate = o.terminationDate;
		/**@type {?string}*/this.terminationReason = o.terminationReason;
		/**@type {?string}*/this.title = o.title;
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?boolean}*/this.eConsent = o.eConsent;
		/**@type {?string}*/this.memberId = o.memberId;
		/**@type {?boolean}*/this.isQle = o.isQle;
		/**@type {?string}*/this.carrier = o.carrier;
		/**@type {?string}*/this.state = o.state;
		/**@type {?boolean}*/this.isNewlyEligible = o.isNewlyEligible;
		/**@type {?boolean}*/this.isNewHire = o.isNewHire;
		/**@type {?RosterMember}*/this.rosterMember = o.rosterMember;
		/**@type {?string}*/this.billingAccountId = o.billingAccountId;
		/**@type {?string}*/this.studentType = o.studentType;
		/**@type {?string}*/this.employerId = o.employerId;
	}
}

export class RosterMember {
	/** @param {RosterMember} o */
	constructor(o) {
		/**@type {?string}*/this.id = o.id;
		/**@type {EnrollmentCohort[]}*/this.enrollmentCohorts = o.enrollmentCohorts;
	}
}

export class EnrollmentCohort {
	/**@param {EnrollmentCohort} o */
	constructor(o){
		/**@type {?string}*/this.id = o.id;
		/**@type {?boolean}*/this.unsubscribe = o.unsubscribe;
		/**@type {?boolean}*/this.hasInteractedShoppingExperience = o.hasInteractedShoppingExperience;
		/**@type {?string}*/this.enrollmentEventId = o.enrollmentEventId;
		/**@type {?boolean}*/this.declineCoverage = o.declineCoverage;
		/**@type {?string}*/this.contractId = o.contractId;
	}
}

export class Address {
	/** @param {Address} o */
	constructor(o) {
		/**@type {?string}*/this.zipCode = o.zipCode;
		/**@type {?string}*/this.street = o.street;
		/**@type {?string}*/this.state = o.state;
		/**@type {?PicklistValue}*/this.stateObject = o.stateObject;
		/**@type {?string}*/this.country = o.country;
		/**@type {?string}*/this.city = o.city;
	}
}

export class PicklistValue {
	/** @param {PicklistValue} o */
	constructor(o) {
		/**@type {?number}*/this.key = o.key;
		/**@type {?string}*/this.text = o.text;
		/**@type {?string}*/this.value = o.value;
	}
}

export class RiderSelection {
	/** @param {RiderSelection} o */
	constructor(o) {
		/**@type {?boolean} */this.selected = o.selected;
		/**@type {?string} */this.name = o.name;
		/**@type {?number} */this.coverage = o.coverage;
	}
}

export class CostPer {
	/**@param {CostPer} o */
	constructor(o) {
		/**@type {?number}*/ this.id = o.id;
		/**@type {?string}*/ this.value = o.value;
	}
}

export class CoPay {
	/** @param {CoPay} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class ConditionFilter {
	/** @param {ConditionFilter} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.value = o.value;
	}
}

export class BenefitLimitsRequest {
	/** @param {BenefitLimitsRequest} o */
	constructor(o) {
		/**@type {?string}*/this.languageCode = o.languageCode;
		/**@type {?string}*/this.statePostalCode = o.statePostalCode;
		/**@type {?ContractTerms}*/this.contractTerms = o.contractTerms;
	}
}

export class BenefitLimitsResponse {
	/** @param {BenefitLimitsResponse} o */
	constructor(o) {
		/**@type {?string}*/this.coveredDuringBenefitWaitingPeriodText = o.coveredDuringBenefitWaitingPeriodText;
		/**@type {?string}*/this.howOftenSubmitClaimText = o.howOftenSubmitClaimText;
		/**@type {?string}*/this.subjectToText = o.subjectToText;
		/**@type {?string}*/this.adminChangeText = o.adminChangeText;
		/**@type {?string}*/this.forEachCategoryText = o.forEachCategoryText;
		/**@type {?string}*/this.waitingPeriodsAdditionalText = o.waitingPeriodsAdditionalText;
		/**@type {BenefitLimitsExplanation[]}*/this.explanations = o.explanations;
	}
}

export class BenefitLimitsExplanation {
	/** @param {BenefitLimitsExplanation} o */
	constructor(o) {
		/**@type {?string}*/this.title = o.title;
		/**@type {?string}*/this.description = o.description;
	}
}

export class ValidateEmployerPasscodeRequest {
	/** @param {ValidateEmployerPasscodeRequest} o */
	constructor(o) {
		/**@type {?string}*/this.employerPasscode = o.employerPasscode;
		/**@type {?string}*/this.token = o.token;
	}
}

export class ValidateEmployerPasscodeResponse {
	/** @param {ValidateEmployerPasscodeResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
	}
}

export class VerifyIdentityBenAdminRequest {
	/** @param {VerifyIdentityBenAdminRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.state = o.state;
		/**@type {?Date}*/this.birthDate = o.birthDate;
	}
}

export class Token {
	/** @param {Token} o */
	constructor(o) {
		/**@type {?string}*/this.tokenType = o.tokenType;
		/**@type {?string}*/this.contractId = o.contractId;
		/**@type {?string}*/this.groupClassId = o.groupClassId;
		/**@type {?string}*/this.employerCode = o.employerCode;
		/**@type {?string}*/this.uiFlow = o.uiFlow;
		/**@type {?any}*/this.extra = o.extra;
		/**@type {?Date}*/this.timestamp = o.timestamp;
	}
}

export class VerifyIdentityBenAdminResponse {
	/** @param {VerifyIdentityBenAdminResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?VerifyIdentityBenAdminData}*/this.data = o.data;
	}
}

export class VerifyIdentityBenAdminData {
	/** @param {VerifyIdentityBenAdminData} o */
	constructor(o) {
		/**@type {?ContractPolicy}*/this.policy = o.policy;
		/**@type {?Eligibility}*/this.eligibility = o.eligibility;
		/**@type {Assumption[]}*/this.limitations = o.limitations;
		/**@type {Assumption[]}*/this.frauds = o.frauds;
		/**@type {?boolean}*/this.stopScreenForUnderaged = o.stopScreenForUnderaged;
	}
}

export class VerifyIdentityRequest {
	/** @param {VerifyIdentityRequest} o */
	constructor(o) {
		/**@type {?string}*/this.birthDate = o.birthDate;
		/**@type {?string}*/this.enrollmentReceivedDate = o.enrollmentReceivedDate;
		/**@type {?QuoteInfo}*/this.quoteInfo = o.quoteInfo;
		/**@type {?string}*/this.ssn = o.ssn;
		/**@type {?Token}*/this.token = o.token;
	}
}

export class VerifyIdentityResponse {
	/** @param {VerifyIdentityResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?VerifyIdentityData}*/this.data = o.data;
	}
}

export class VerifyIdentityData {
	/** @param {VerifyIdentityData} o */
	constructor(o) {
		/**@type {?Date}*/this.enrollmentStartDate = o.enrollmentStartDate;
		/**@type {?Date}*/this.enrollmentEndDate = o.enrollmentEndDate;
		/**@type {?string}*/this.gender = o.gender;
		/**@type {?UserAccount}*/this.account = o.account;
		/**@type {?boolean}*/this.isConverted = o.isConverted;
		/**@type {?boolean}*/this.enrollmentDeclined = o.enrollmentDeclined;
		/**@type {?string}*/this.payrollFrequencySelected = o.payrollFrequencySelected;
		/**@type {?UserProgress}*/this.userProgress = o.userProgress;
		/**@type {?Address}*/this.address = o.address;
		/**@type {?boolean}*/this.isNewHire = o.isNewHire;
		/**@type {?Date}*/this.dateOfHire = o.dateOfHire;
		/**@type {?number}*/this.ageAtPolicyEffectiveDate = o.ageAtPolicyEffectiveDate;
		/**@type {?Tiers}*/this.employerContribution = o.employerContribution;
		/**@type {?boolean}*/this.isEligibilityLoss = o.isEligibilityLoss;
		/**@type {?boolean}*/this.hasContractToEnrolTo = o.hasContractToEnrolTo;
		/**@type {?Date}*/this.coverageEffectiveDate = o.coverageEffectiveDate;
		/**@type {?ContractPolicy}*/this.policy = o.policy;
		/**@type {?Eligibility}*/this.eligibility = o.eligibility;
		/**@type {Assumption[]}*/this.limitations = o.limitations;
		/**@type {Assumption[]}*/this.frauds = o.frauds;
		/**@type {?boolean}*/this.stopScreenForUnderaged = o.stopScreenForUnderaged;
	}
}

export class UserAccount {
	/** @param {UserAccount} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.username = o.username;
		/**@type {?string}*/this.description = o.description;
		/**@type {?string}*/this.email = o.email;
		/**@type {?boolean}*/this.mustResetPassword = o.mustResetPassword;
		/**@type {?boolean}*/this.active = o.active;
		/**@type {?Date}*/this.createdTime = o.createdTime;
		/**@type {?number}*/this.credentialTypeId = o.credentialTypeId;
	}
}

export class UserProgress {
	/** @param {UserProgress} o */
	constructor(o) {
		/**@type {?number}*/this.id = o.id;
		/**@type {?string}*/this.enrolleeSfId = o.enrolleeSfId;
		/**@type {?any}*/this.data = o.data;
		/**@type {?string}*/this.contractId = o.contractId;
	}
}

export class RegisterActionRequest {
	/** @param {RegisterActionRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.actionType = o.actionType;
		/**@type {?any}*/this.data = o.data;
	}
}

export class UpsertUserProgressRequest {
	/** @param {UpsertUserProgressRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?UserProgress}*/this.userProgress = o.userProgress;
	}
}

export class UpsertUserProgressResponse {
	/** @param {UpsertUserProgressResponse} o */
	constructor(o) {
		/**@type {?number}*/this.userProgressId = o.userProgressId;
	}
}

export class PrepareDiagnosisRequest {
	/** @param {PrepareDiagnosisRequest} o */
	constructor(o) {
		/**@type {?string}*/this.token = o.token;
		/**@type {?number}*/this.maritalStatusId = o.maritalStatusId;
		/**@type {?number}*/this.dependentsId = o.dependentsId;
		/**@type {?float}*/this.moderateBenefit = o.moderateBenefit;
		/**@type {?float}*/this.severeBenefit = o.severeBenefit;
		/**@type {?float}*/this.catastrophicBenefit = o.catastrophicBenefit;
		/**@type {?float}*/this.mentalBenefit = o.mentalBenefit;
		/**@type {?float}*/this.chronicBenefit = o.chronicBenefit;
		/**@type {?float}*/this.maternityBenefit = o.maternityBenefit;
		/**@type {?number}*/this.ageAtPolicyEffectiveDate = o.ageAtPolicyEffectiveDate;
		/**@type {?string}*/this.payrollFrequencySelected = o.payrollFrequencySelected;
		/**@type {?string}*/this.planOffering = o.planOffering;
		/**@type {?Tiers}*/this.employerContribution = o.employerContribution;
		/**@type {?QuoteInfo}*/this.quoteInfo = o.quoteInfo;
		/**@type {?Presets}*/this.presets = o.presets;
		/**@type {RatedClassRates[]}*/this.ratedClassRates = o.ratedClassRates;
	}
}

export class PrepareDiagnosisResponse {
	/** @param {PrepareDiagnosisResponse} o */
	constructor(o) {
		/**@type {?float}*/this.costEE = o.costEE;
		/**@type {?float}*/this.costTier = o.costTier;
	}
}

export class BenefitLimitsShortExplanationsRequest {
	/**@param {BenefitLimitsShortExplanationsRequest} o */
	constructor(o){
		/**@type {?string}*/this.languageCode = o.languageCode
		/**@type {?ContractTerms}*/this.contractTerms = o.contractTerms
	}
}

export class BenefitLimitsShortExplanationsResponse {
	/**@param {BenefitLimitsShortExplanationsResponse} o */
	constructor(o){
		/**@type {BenefitLimitsShortExplanation[]}*/this.explanations = o.explanations
	}
}

export class BenefitLimitsShortExplanation {
	/**@param {BenefitLimitsShortExplanation} o */
	 constructor(o) {
		/**@type {?string}*/this.category = o.category
		/**@type {?string}*/this.description = o.description
	}
}

export class ListConditionsWithKeywordRequest {
	/**@param {ListConditionsWithKeywordRequest} o */
	constructor(o) {
		/**@type {?boolean}*/this.hasChronic = o.hasChronic;
		/**@type {?boolean}*/this.hasMental = o.hasMental;
		/**@type {?boolean}*/this.hasMaternity = o.hasMaternity;
		/**@type {?number}*/this.page = o.page;
		/**@type {?string}*/this.conditionListVersionSfId = o.conditionListVersionSfId;
	}
}

export class ListConditionsWithKeywordResponse {
	/**@param {ListConditionsWithKeywordResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?ListConditionsWithKeywordData}*/this.data = o.data;
	}
}

export class ListConditionsWithKeywordData {
	/**@param {ListConditionsWithKeywordData} o */
	constructor(o) {
		/**@type {ConditionBasicInfo[]}*/this.conditions = o.conditions;
		/**@type {?boolean}*/this.isLastPage = o.isLastPage;
	}
}

export class ConditionBasicInfo {
	/**@param {ConditionBasicInfo} o */
	constructor(o) {
		/**@type {?boolean}*/this.includedCondition = o.includedCondition;
		/**@type {?string}*/this.conditionCode = o.conditionCode;
		/**@type {?string}*/this.conditionName = o.conditionName;
		/**@type {?string}*/this.conditionGroupName = o.conditionGroupName;
		/**@type {?string}*/this.keywordName = o.keywordName;
	}
}

export class PersonalizePlanRequest {
	/** @param {PersonalizePlanRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.familyTierValue = o.familyTierValue;
		/**@type {?float}*/this.moderateBenefit = o.moderateBenefit;
		/**@type {?float}*/this.severeBenefit = o.severeBenefit;
		/**@type {?float}*/this.catastrophicBenefit = o.catastrophicBenefit;
		/**@type {?float}*/this.mentalBenefit = o.mentalBenefit;
		/**@type {?float}*/this.chronicBenefit = o.chronicBenefit;
		/**@type {?float}*/this.maternityBenefit = o.maternityBenefit;
		/**@type {?number}*/this.ageAtPolicyEffectiveDate = o.ageAtPolicyEffectiveDate;
		/**@type {?string}*/this.payrollFrequencySelected = o.payrollFrequencySelected;
		/**@type {?QuoteInfo}*/this.quoteInfo = o.quoteInfo;
		/**@type {?Presets}*/this.presets = o.presets;
		/**@type {?boolean}*/this.userModifiedData = o.userModifiedData;
		/**@type {?UserActionData}*/this.userActionData = o.userActionData;
		/**@type {?string}*/this.planOffering = o.planOffering;
		/**@type {RatedClassRates[]}*/this.ratedClassRates = o.ratedClassRates;
	}
}

export class UserActionData {
	/** @param {UserActionData} o */
	constructor(o) {
		/**@type {?string}*/this.brellaSelectPlan = o.brellaSelectPlan;
	}
}

export class PersonalizePlanResponse {
	/** @param {PersonalizePlanResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?PersonalizePlanData}*/this.data = o.data;
	}
}

export class PersonalizePlanData {
	/** @param {PersonalizePlanData} o */
	constructor(o) {
		/**@type {?float}*/this.costChoice = o.costChoice;
		/**@type {?float}*/this.costValue = o.costValue;
		/**@type {?float}*/this.costEnhanced = o.costEnhanced;
		/**@type {?float}*/this.costPremier = o.costPremier;
		/**@type {?float}*/this.contribChoice = o.contribChoice;
		/**@type {?float}*/this.contribValue = o.contribValue;
		/**@type {?float}*/this.contribEnhanced = o.contribEnhanced;
		/**@type {?float}*/this.contribPremier = o.contribPremier;
	}
}

export class SubmitPlanDetailsRequest {
	/** @param {SubmitPlanDetailsRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?number}*/this.maritalStatusId = o.maritalStatusId;
		/**@type {?number}*/this.dependentsId = o.dependentsId;
		/**@type {?number}*/this.copayId = o.copayId;
		/**@type {?number}*/this.highDeductibleInfoId = o.highDeductibleInfoId;
		/**@type {?number}*/this.leftoverMoneyId = o.leftoverMoneyId;
		/**@type {?number}*/this.ageAtPolicyEffectiveDate = o.ageAtPolicyEffectiveDate;
	}
}

export class SubmitPlanDetailsResponse {
	/** @param {SubmitPlanDetailsResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?SubmitPlanDetailsData}*/this.data = o.data;
	}
}

export class SubmitPlanDetailsData {
	/** @param {SubmitPlanDetailsData} o */
	constructor(o) {
		/**@type {?string}*/this.familyTierValue = o.familyTierValue;
		/**@type {?ResultChoice}*/this.choice = o.choice;
		/**@type {?ResultSelect}*/this.select = o.select;
	}
}

export class ResultChoice {
	/** @param {ResultChoice} o */
	constructor(o) {
		/**@type {?float}*/this.cost = o.cost;
		/**@type {?number}*/this.moderatePoints = o.moderatePoints;
		/**@type {?number}*/this.severePoints = o.severePoints;
		/**@type {?number}*/this.catastrophicPoints = o.catastrophicPoints;
		/**@type {?number}*/this.moderateBenefit = o.moderateBenefit;
		/**@type {?number}*/this.severeBenefit = o.severeBenefit;
		/**@type {?number}*/this.catastrophicBenefit = o.catastrophicBenefit;
	}
}

export class ResultSelect {
	/** @param {ResultSelect} o */
	constructor(o) {
		/**@type {?float}*/this.cost = o.cost;
		/**@type {?number}*/this.moderateBenefit = o.moderateBenefit;
		/**@type {?number}*/this.severeBenefit = o.severeBenefit;
		/**@type {?number}*/this.catastrophicBenefit = o.catastrophicBenefit;
		/**@type {?string}*/this.selectPreset = o.selectPreset;
		/**@type {?number}*/this.selectPoints = o.selectPoints;
	}
}

export class UpsertDependentRequest {
	/** @param {UpsertDependentRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?FamilyMember}*/this.dependent = o.dependent;
		/**@type {?string}*/this.languageCode = o.languageCode;
	}
}

export class FamilyMember {
	/** @param {FamilyMember} o */
	constructor(o) {
		/**@type {?Address}*/this.address = o.address;
		/**@type {?Date}*/this.birthdate = o.birthdate;
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.gender = o.gender;
		/**@type {?string}*/this.id = o.id;
		/**@type {?boolean}*/this.isQualifiedForCoverage = o.isQualifiedForCoverage;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {?string}*/this.middleName = o.middleName;
		/**@type {?string}*/this.relationship = o.relationship;
		/**@type {?string}*/this.ssn = o.ssn;
		/**@type {?string}*/this.studentStatus = o.studentStatus;
		/**@type {?string}*/this.suffix = o.suffix;
	}
}

export class UpsertDependentResponse {
	/** @param {UpsertDependentResponse} o */
	constructor(o) {
		/**@type {?string}*/this.error = o.error;
		/**@type {?string}*/this.rosterFamilyMemberId = o.rosterFamilyMemberId;
		/**@type {?boolean}*/this.success = o.success;
	}
}

export class DeleteDependentRequest {
	/** @param {DeleteDependentRequest} o */
	constructor(o) {
		/**@type {?string}*/this.dependentId = o.dependentId;
	}
}

export class DeleteDependentResponse {
	/** @param {DeleteDependentResponse} o */
	constructor(o) {
		/**@type {?string}*/this.error = o.error;
		/**@type {?boolean}*/this.success = o.success;
	}
}

export class PrepareReviewRequest {
	/** @param {PrepareReviewRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
	}
}

export class PrepareReviewResponse {
	/** @param {PrepareReviewResponse} o */
	constructor(o) {
		/**@type {?string}*/this.plaidEnvironment = o.plaidEnvironment;
		/**@type {?string}*/this.plaidLinkToken = o.plaidLinkToken;
		/**@type {?string}*/this.stripePublicKey = o.stripePublicKey;
		/**@type {PaymentMethodInfo[]}*/this.bankAccounts = o.bankAccounts;
		/**@type {?string}*/this.billingMethod = o.billingMethod;
		/**@type {?MicroDepositsBankAccount}*/this.microDepositsBankAccount = o.microDepositsBankAccount;
	}
}

export class SearchConditionsRequest {
	/** @param {SearchConditionsRequest} o */
	constructor(o) {
		/**@type {?string}*/this.searchTerm = o.searchTerm;
		/**@type {?string}*/this.conditionListVersionSfId = o.conditionListVersionSfId;
		/**@type {?number}*/this.resultsPerPage = o.resultsPerPage;
		/**@type {?number}*/this.page = o.page;
		/**@type {?string}*/this.orderBy = o.orderBy;
		/**@type {?boolean}*/this.orderDescending = o.orderDescending;
	}
}

export class SearchConditionsResponse {
	/** @param {SearchConditionsResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?SearchConditionsResponseData}*/this.data = o.data;
	}
}

export class SearchConditionsResponseData {
	/** @param {SearchConditionsResponseData} o */
	constructor(o) {
		/**@type {?ConditionBasicInfo[]}*/this.data = o.data;
		/**@type {?number}*/this.totalResults = o.totalResults;
		/**@type {?number}*/this.resultsPerPage = o.resultsPerPage;
		/**@type {?number}*/this.page = o.page;
		/**@type {?string}*/this.orderBy = o.orderBy;
		/**@type {?boolean}*/this.orderDescending = o.orderDescending;
	}
}

export class ResetTokenRequest {
	/** @param {ResetTokenRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.email = o.email;
	}
}

export class ResetTokenResponse {
	/** @param {ResetTokenResponse} o */
	constructor(o) {
		/**@type {?boolean}*/this.isMember = o.isMember;
		/**@type {?number}*/this.status = o.status;
	}
}

export class RequestResetPasswordRequest {
	/** @param {RequestResetPasswordRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.email = o.email;
	}
}

export class SubmitCaseRequest {
	/** @param {SubmitCaseRequest} o */
	constructor(o) {
		/**@type {?string}*/this.employerId = o.employerId;
		/**@type {?string}*/this.name = o.name;
		/**@type {?string}*/this.subject = o.subject;
		/**@type {?string}*/this.message = o.message;
		/**@type {?string}*/this.phone = o.phone;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.uiFlow = o.uiFlow;
	}
}

export class ResetPasswordRequest {
	/** @param {ResetPasswordRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.resetPasswordToken = o.resetPasswordToken;
		/**@type {?string}*/this.password = o.password;
	}
}

export class ResetPasswordResponse {
	/** @param {ResetPasswordResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?Token}*/this.newToken = o.newToken;
	}
}

export class UnsubscribeRequest {
	/** @param {UnsubscribeRequest} o */
	constructor(o) {
		/**@type {?string}*/this.email = o.email;
		/**@type {?Token}*/this.token = o.token;
	}
}

export class UnsubscribeResponse {
	/** @param {UnsubscribeResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
	}
}

export class DeclineCoverageRequest {
	/** @param {DeclineCoverageRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {string[]}*/this.reasons = o.reasons;
		/**@type {?string}*/this.explanation = o.explanation;
	}
}

export class PrepareSummaryRequest {
	/** @param {PrepareSummaryRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
	}
}

export class PrepareSummaryResponse {
	/** @param {PrepareSummaryResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?PrepareSummaryResponseData}*/this.data = o.data;
	}
}

export class PrepareSummaryResponseData {
	/** @param {PrepareSummaryResponseData} o */
	constructor(o) {
		/**@type {?Employer}*/this.employer = o.employer;
		/**@type {?Broker}*/this.broker = o.broker;
		/**@type {?Contact}*/this.certificateHolder = o.certificateHolder;
		/**@type {?Certificate}*/this.certificate = o.certificate;
		/**@type {?float}*/this.cost = o.cost;
		/**@type {?float}*/this.employerContribution = o.employerContribution;
	}
}

export class Broker {
	/** @param {Broker} o */
	constructor(o) {
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.taxId = o.taxId;
		/**@type {?string}*/this.status = o.status;
		/**@type {?string}*/this.segment = o.segment;
		/**@type {?PrimaryContact}*/this.primaryContact = o.primaryContact;
		/**@type {?string}*/this.phone = o.phone;
		/**@type {?string}*/this.nationalProducerNumber = o.nationalProducerNumber;
		/**@type {?boolean}*/this.nationalBroker = o.nationalBroker;
		/**@type {?string}*/this.name = o.name;
		/**@type {?AppointmentData}*/this.agencyAppointment = o.agencyAppointment;
		/**@type {?Address}*/this.address = o.address;
		/**@type {?Contact}*/this.salesRepresentative = o.salesRepresentative;
		/**@type {Employer[]}*/this.agencyEmployerRelationships = o.agencyEmployerRelationships;
		/**@type {Producer[]}*/this.producers = o.producers;
		/**@type {?string}*/this.generalAgencyId = o.generalAgencyId;
		/**@type {?string}*/this.agencyBrokerageId = o.agencyBrokerageId;
	}
}

export class PrimaryContact {
	/** @param {PrimaryContact} o */
	constructor(o) {
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.accountId = o.accountId;
		/**@type {?string}*/this.title = o.title;
		/**@type {?string}*/this.socialSecurityNumber = o.socialSecurityNumber;
		/**@type {?string}*/this.phone = o.phone;
		/**@type {?string}*/this.nationalProducerNumber = o.nationalProducerNumber;
		/**@type {?string}*/this.mobilePhone = o.mobilePhone;
		/**@type {?string}*/this.middleName = o.middleName;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.contactPreference = o.contactPreference;
		/**@type {?Date}*/this.birthDate = o.birthDate;
		/**@type {?Address}*/this.address = o.address;
		/**@type {?boolean}*/this.brellaPortalContact = o.brellaPortalContact;
		/**@type {?string}*/this.accountName = o.accountName;
	}
}

export class AppointmentData {
	/** @param {AppointmentData} o */
	constructor(o) {
		/**@type {?boolean}*/this.unsatisfiedJudgmentsAgainstIt = o.unsatisfiedJudgmentsAgainstIt;
		/**@type {?Date}*/this.submittedDate = o.submittedDate;
		/**@type {?boolean}*/this.subjectToComplain = o.subjectToComplain;
		/**@type {?string}*/this.status = o.status;
		/**@type {?string}*/this.policyNumber = o.policyNumber;
		/**@type {?boolean}*/this.litigationOrInvestigation = o.litigationOrInvestigation;
		/**@type {?boolean}*/this.licenseAppointmentSuspended = o.licenseAppointmentSuspended;
		/**@type {?string}*/this.jurisdictionCode = o.jurisdictionCode;
		/**@type {?boolean}*/this.filedForBankrupcy = o.filedForBankrupcy;
		/**@type {?string}*/this.errorsAndOmissionsCarrier = o.errorsAndOmissionsCarrier;
		/**@type {?boolean}*/this.errorsAndOmissions = o.errorsAndOmissions;
		/**@type {?number}*/this.amountOfCoverage = o.amountOfCoverage;
		/**@type {?boolean}*/this.wantReportCopy = o.wantReportCopy;
		/**@type {?boolean}*/this.completedAML = o.completedAML;
		/**@type {?boolean}*/this.beenConvicted = o.beenConvicted;
		/**@type {?string}*/this.linesOfAuthority = o.linesOfAuthority;
		/**@type {?string}*/this.category = o.category;
		/**@type {?boolean}*/this.agree = o.agree;
		/**@type {?boolean}*/this.certify = o.certify;
	}
}

export class Producer {
	/** @param {Producer} o */
	constructor(o) {
		/**@type {?PrimaryContact}*/this.producerContact = o.producerContact;
		/**@type {?AppointmentData}*/this.producerAppointment = o.producerAppointment;
	}
}

export class Certificate {
	/** @param {Certificate} o */
	constructor(o) {
		/**@type {?string}*/this.recordTypeId = o.recordTypeId;
		/**@type {?string}*/this.assetGroupId = o.assetGroupId;
		/**@type {?string}*/this.id = o.id;
		/**@type {?boolean}*/this.useBrellaEnrollment = o.useBrellaEnrollment;
		/**@type {?number}*/this.tierFactor = o.tierFactor;
		/**@type {?string}*/this.status = o.status;
		/**@type {?string}*/this.stateCode = o.stateCode;
		/**@type {?number}*/this.premium = o.premium;
		/**@type {?number}*/this.monthlyPremium = o.monthlyPremium;
		/**@type {?string}*/this.planName = o.planName;
		/**@type {?string}*/this.planId = o.planId;
		/**@type {?string}*/this.familyTier = o.familyTier;
		/**@type {?Date}*/this.expirationDate = o.expirationDate;
		/**@type {?Date}*/this.effectiveDate = o.effectiveDate;
		/**@type {?string}*/this.certificateNumber = o.certificateNumber;
		/**@type {?number}*/this.ageAtPolicyEffectiveDate = o.ageAtPolicyEffectiveDate;
		/**@type {?Date}*/this.enrollmentStartDate = o.enrollmentStartDate;
		/**@type {?Date}*/this.enrollmentEndDate = o.enrollmentEndDate;
		/**@type {?string}*/this.billingGroupField = o.billingGroupField;
		/**@type {?string}*/this.billingGroupCustomField = o.billingGroupCustomField;
		/**@type {?string}*/this.amendmentReason = o.amendmentReason;
		/**@type {?string}*/this.versionReason = o.versionReason;
		/** @type {Contact[]} */ this.dependents = o.dependents;
		/** @type {?Benefits} */ this.assetCoverages = o.assetCoverages;
		/** @type {?RatedClass} */ this.ratedClass = o.ratedClass;
		/** @type {?float} */this.enrollmentPaymentDue = o.enrollmentPaymentDue;
		/** @type {?Date} */this.enrollmentPaymentDueDate = o.enrollmentPaymentDueDate;
		/** @type {?float} */this.enrollmentPaymentPaid = o.enrollmentPaymentPaid;
		/** @type {?string} */this.enrollmentPaymentStatus = o.enrollmentPaymentStatus;
		/** @type {?PaymentMethod} */this.enrollmentPaymentMethod = o.enrollmentPaymentMethod;
		/** @type {?boolean} */this.autoPay = o.autoPay;
		/** @type {?string} */this.contractId = o.contractId;
		/** @type {?string} */this.carrier = o.carrier;
		/** @type {?string} */this.state = o.state;
		/** @type {?string} */this.conditionListVersionId = o.conditionListVersionId;
		/** @type {?boolean} */this.isCurrent = o.isCurrent;
		/** @type {?boolean} */this.displayCoveragePlan = o.displayCoveragePlan;
	}
}

export class Benefits {
	/** @param {Benefits} o */
	constructor(o) {
		/**@type {?number}*/this.moderate = o.moderate;
		/**@type {?number}*/this.severe = o.severe;
		/**@type {?number}*/this.catastrophic = o.catastrophic;
		/**@type {?number}*/this.chronic = o.chronic;
		/**@type {?number}*/this.mental = o.mental;
		/**@type {?number}*/this.maternity = o.maternity;
	}
}

export class PaymentMethod {
	/** @param {PaymentMethod} o */
	constructor(o) {
		/**@type {?string}*/this.paymentMethod = o.paymentMethod;
	}
}

export class ScheduleEmailRecommendationRequest {
	/** @param {ScheduleEmailRecommendationRequest} o */
	constructor(o) {
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.moderateRecommendation = o.moderateRecommendation;
		/**@type {?string}*/this.severeRecommendation = o.severeRecommendation;
		/**@type {?string}*/this.catastrophicRecommendation = o.catastrophicRecommendation;
		/**@type {?string|undefined}*/this.chronicTitle = o.chronicTitle;
		/**@type {?string|undefined}*/this.chronicDescription = o.chronicDescription;
		/**@type {?string}*/this.chronic = o.chronic;
		/**@type {?string|undefined}*/this.mentalTitle = o.mentalTitle;
		/**@type {?string|undefined}*/this.mentalDescription = o.mentalDescription;
		/**@type {?string}*/this.mental = o.mental;
		/**@type {?string}*/this.maternityTitle = o.maternityTitle;
		/**@type {?string}*/this.maternityDescription = o.maternityDescription;
		/**@type {?string}*/this.maternity = o.maternity;
		/**@type {?string}*/this.employerContribution = o.employerContribution;
		/**@type {?string}*/this.yourTotalCost = o.yourTotalCost;
		/**@type {?string}*/this.mailTo = o.mailTo;
		/**@type {?string}*/this.payFrequency = o.payFrequency;
		/**@type {?string}*/this.iWantToCover = o.iWantToCover;
		/**@type {?string}*/this.uiFlow = o.uiFlow;
		/**@type {?string}*/this.language = o.language;
		/**@type {?string}*/this.openEnrollmentStarts = o.openEnrollmentStarts;
		/**@type {?string|undefined}*/this.riderLabels = o.riderLabels;
		/**@type {?string}*/this.groupType = o.groupType;
	}
}

export class SubmitPlanInfoRequest {
	/** @param {SubmitPlanInfoRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.familyTierValue = o.familyTierValue;
		/**@type {?number}*/this.moderateBenefit = o.moderateBenefit;
		/**@type {?number}*/this.severeBenefit = o.severeBenefit;
		/**@type {?number}*/this.catastrophicBenefit = o.catastrophicBenefit;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.middleName = o.middleName;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {?string}*/this.suffix = o.suffix;
		/**@type {?string}*/this.phoneNumber = o.phoneNumber;
		/**@type {?string}*/this.phoneType = o.phoneType;
		/**@type {?Address}*/this.address = o.address;
		/**@type {FamilyMember[]}*/this.familyMembers = o.familyMembers;
		/**@type {?string}*/this.password = o.password;
		/**@type {?string}*/this.gender = o.gender;
		/**@type {?Date}*/this.enrollmentReceivedDate = o.enrollmentReceivedDate;
		/**@type {?CreditCardData}*/this.creditCardData = o.creditCardData;
		/**@type {?BankAccountData}*/this.bankAccountData = o.bankAccountData;
		/**@type {?string}*/this.amount = o.amount;
		/**@type {?boolean}*/this.autoPay = o.autoPay;
		/**@type {?boolean}*/this.isBillingEnabled = o.isBillingEnabled;
		/**@type {?Date}*/this.benefitEligibilityDate = o.benefitEligibilityDate;
		/**@type {?number}*/this.chronicBenefit = o.chronicBenefit;
		/**@type {?string}*/this.chronicTitle = o.chronicTitle;
		/**@type {?number}*/this.mentalBenefit = o.mentalBenefit;
		/**@type {?string}*/this.mentalTitle = o.mentalTitle;
		/**@type {?number}*/this.maternityBenefit = o.maternityBenefit;
		/**@type {?string}*/this.maternityTitle = o.maternityTitle;
		/**@type {?string}*/this.policyEffectiveDate = o.policyEffectiveDate;
		/**@type {?string}*/this.payrollFrequency = o.payrollFrequency;
		/**@type {?string}*/this.paymentMethodStatus = o.paymentMethodStatus;
		/**@type {?boolean}*/this.policyReplacementQuestion = o.policyReplacementQuestion;
        /**@type {?boolean}*/this.policyLimitedQuestion = o.policyLimitedQuestion;
        /**@type {?boolean}*/this.policyBenefitsQuestion = o.policyBenefitsQuestion;
        /**@type {?boolean}*/this.comprehensiveCoverageQuestion = o.comprehensiveCoverageQuestion;
	}
}

export class CreditCardData {
	/** @param {CreditCardData} o */
	constructor(o) {
		/**@type {?string}*/this.paymentMethodId = o.paymentMethodId;
	}
}

export class BankAccountData {
	/** @param {BankAccountData} o */
	constructor(o) {
		/**@type {?string}*/this.paymentMethodId = o.paymentMethodId;
		/**@type {?string}*/this.last4 = o.last4;
	}
}

export class SubmitPlanInfoResponse {
	/** @param {SubmitPlanInfoResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?any}*/this.data = o.data;
	}
}

export class AddMicroDepositsOrBankAccountRequest {
	/** @param {AddMicroDepositsOrBankAccountRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.firstName = o.firstName;
		/**@type {?string}*/this.lastName = o.lastName;
		/**@type {?string}*/this.publicToken = o.publicToken;
		/**@type {?string}*/this.accountId = o.accountId;
		/**@type {?string}*/this.accountSfId = o.accountSfId;
		/**@type {Map<string, string>|undefined}*/this.metadata = o.metadata;
	}
}

export class AddBankAccountResponse {
	/** @param {AddBankAccountResponse} o */
	constructor(o) {
		/**@type {?number}*/this.status = o.status;
		/**@type {?string}*/this.statusText = o.statusText;
		/**@type {?AddBankAccountData}*/this.data = o.data;
	}
}

export class AddBankAccountData {
	/** @param {AddBankAccountData} o */
	constructor(o) {
		/**@type {?BankAccount}*/this.bankAccounts = o.bankAccounts;
		/**@type {?PaymentMethodInfo}*/this.paymentMethodInfo = o.paymentMethodInfo;
	}
}

export class BankAccount {
	/** @param {BankAccount} o */
	constructor(o) {
		/**@type {?string}*/this.id = o.id;
		/**@type {?string}*/this.fingerprint = o.fingerprint;
		/**@type {?string}*/this.last4 = o.last4;
		/**@type {?string}*/this.bankName = o.bankName;
		/**@type {?string}*/this.country = o.country;
		/**@type {?string}*/this.currency = o.currency;
		/**@type {?string}*/this.status = o.status;
	}
}

export class RemoveBankAccountRequest {
	/** @param {RemoveBankAccountRequest} o */
	constructor(o) {
		/**@type {?Token}*/this.token = o.token;
		/**@type {?string}*/this.email = o.email;
		/**@type {?string}*/this.paymentMethodId = o.paymentMethodId;
		/**@type {?string}*/this.accountId = o.accountId;
	}
}

export class RemoveMicroDepositsBankAccountRequest {
	/** @param {RemoveMicroDepositsBankAccountRequest} o */
	constructor(o) {
		/**@type {?string}*/this.accountId = o.accountId;
	}
}
